import { render, staticRenderFns } from "./NotificationStack.vue?vue&type=template&id=111c4cd6"
import script from "./NotificationStack.vue?vue&type=script&lang=js"
export * from "./NotificationStack.vue?vue&type=script&lang=js"
import style0 from "./NotificationStack.vue?vue&type=style&index=0&id=111c4cd6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports